import { render, staticRenderFns } from "./query-record.vue?vue&type=template&id=5e3eb7c2&scoped=true&"
import script from "./query-record.vue?vue&type=script&lang=js&"
export * from "./query-record.vue?vue&type=script&lang=js&"
import style0 from "./query-record.vue?vue&type=style&index=0&id=5e3eb7c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3eb7c2",
  null
  
)

export default component.exports